import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

type InfoCellType = 'main';

@Component({
	selector: 'info-cell',
	templateUrl: './info-cell.component.html',
	styleUrls: ['./info-cell.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class InfoCellComponent {
	@HostBinding('class') readonly hostClass = 'info-cell';

	@Input() title = '';
	@Input() value: string | number | null = null;
	@Input() type?: InfoCellType;

	@HostBinding('class.info-cell--main')
	get isMainInfoClass(): boolean {
		return this.type === 'main';
	}
}
